import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './components/App';
import FallbackPage from './components/pages/FallbackPage';
import i18n from './i18n/i18n';
import { persistor, store } from './store';
import './styles/general.scss';
import { getAppBasename } from './utils/helper';

const basename = getAppBasename();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={basename}>
            <ErrorBoundary FallbackComponent={FallbackPage}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <HelmetProvider>
                            <App />
                        </HelmetProvider>
                    </PersistGate>
                </Provider>
            </ErrorBoundary>
        </BrowserRouter>
    </I18nextProvider>
);
